<template>
    <Modal v-model="isShowModal" fullscreen footer-hide>
      <div v-if="isShowModal" class="contact-detail-modal-root-container">
        <div class="contact-detail-top-container">
          <div style="display: flex; flex-direction: row; align-items: center">
            <div style="font-size: 32px; font-weight: bold; color: #000000">
              {{ userInfo.client_user_name }}
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-left: 20px;
              "
            >
              <img :src="icons.pass" />
              <div
                style="
                  font-size: 12px;
                  font-weight: bold;
                  color: #2b2b2b;
                  margin-left: 5px;
                "
              >
                已通过个人认证
              </div>
            </div>
          </div>
          <div class="contact-detail-info-container">
            <my-avatar
              style="margin-top: 20px"
              :size="83"
              :name="userInfo.client_user_name"
            ></my-avatar>
            <div style="margin-top: 30px" class="contact-detail-info-item">
              <Icon :size="34" type="md-phone-portrait" />
              <div
                style="
                  font-size: 15px;
                  font-weight: bold;
                  color: #5f5f5f;
                  margin-left: 10px;
                  min-width: 70px;
                "
              >
                手机号
              </div>
              <div style="font-size: 15px; color: #5f5f5f">
                {{ userInfo.client_user_phone }}
              </div>
            </div>
            <!-- <div style="margin-top: 20px" class="contact-detail-info-item">
              <Icon :size="34" type="md-mail" />
              <div
                style="
                  font-size: 15px;
                  font-weight: bold;
                  color: #5f5f5f;
                  margin-left: 10px;
                  min-width: 70px;
                "
              >
                邮箱
              </div>
              <div style="font-size: 15px; color: #5f5f5f">--</div>
            </div> -->
            <div style="margin-top: 30px" class="contact-detail-info-item">
              <img :src="icons.idcard" style="width: 34px; height: 24px" />
              <div
                style="
                  font-size: 15px;
                  font-weight: bold;
                  color: #5f5f5f;
                  margin-left: 10px;
                  min-width: 70px;
                "
              >
                身份证
              </div>
              <div style="font-size: 15px; color: #5f5f5f">
                {{ userInfo.client_user_idnum }}
              </div>
            </div>
            <div style="margin-top: 30px" class="contact-detail-info-item">
              <Icon type="md-document" :size="35" />
              <div
                style="
                  font-size: 15px;
                  font-weight: bold;
                  color: #5f5f5f;
                  margin-left: 10px;
                  min-width: 70px;
                "
              >
                协议
              </div>
              <Button
                type="text"
                size="small"
                style="margin-top: 2px; margin-left: -10px"
                @click="viewService"
                >点击查看</Button
              >
            </div>
          </div>
        </div>
        <div class="contact-detail-bottom-container">
        <!-- 标签切换行 -->
        <div class="tab-row">
          <!-- 标签切换 -->
          <div class="tab-list-container">
            <slide-tabbar
              :tabs="tabs"
              @on-change="onBarChange"
              show-bar
            ></slide-tabbar>
          </div>
          <!-- 添加日历选择和统计功能 -->
          <div class="date-picker-container">
            <div class="date-picker-wrapper">
              <span style="margin-right: 10px"
                >{{ start_time_format }}至{{ end_time_format }}</span
              >
              <Button
                size="small"
                icon="md-calendar"
                type="text"
                @click="showTimeDrawer"
                >设置日期</Button
              >
            </div>
            <div class="total-amount">
              总金额：<fee
                :amount="totalAmount"
                :primarySize="16"
                :secondarySize="14"
              />
            </div>
          </div>
        </div>

        <!-- 交易列表 -->
        <div
          v-if="currentIndex == 0"
          class="contact-detail-trade-list-container"
        >
          <trade-item
            v-for="item in filteredLogList"
            :key="item.card_log_id"
            :data-source="item"
          />
        </div>

        <!-- 额外信息 -->
        <div v-else-if="currentIndex == 1" class="contact-detail-trade-list-container">
          <div v-for="item in extInfo" :key="item.key" class="ext-row">
            <span style="margin-right: 50px; min-width: 200px">{{
              item.desc
            }}:</span>
            <img v-if="item.type == 'img'" :src="item.val" style="max-width:200px;"/>
            <span v-else>{{ item.val }}</span>
          </div>
        </div>

        <!-- 项目列表 -->
        <div
          v-else
          class="contact-detail-project-list-container"
        >
          <project-item
            v-for="item in projectList"
            :key="item.project_id"
            :data-source="item"
            @click.native="gotoProject(item)"
          />
        </div>
      </div>
    </div>

    <!-- 日期选择抽屉 -->
    <time-drawer ref="timeDrawer" @setTime="setTime" />
  </Modal>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import * as icon from "../../../common/icon";
import moment from "moment";
import MyAvatar from "../../../components/MyAvatar";
import ProjectItem from "../Item/ProjectItem";
import SlideTabbar from "../../../components/SlideTabbar";
import Fee from "../../../components/Fee"; // 引入 Fee 组件
import TimeDrawer from "../../Home/Drawer/TimeDrawer"; // 根据实际路径调整

export default {
  components: {
    "my-avatar": MyAvatar,
    "project-item": ProjectItem,
    "slide-tabbar": SlideTabbar,
    Fee, // 注册 Fee 组件
    "time-drawer": TimeDrawer, // 注册 TimeDrawer 组件
  },
  data() {
    return {
      isShowModal: false,
      icons: icon,
      currentIndex: 0,
      client_user_id: 0,
      userInfo: {},
      extInfo: [],
      logList: [], // 原始交易列表
      filteredLogList: [], // 过滤后的交易列表
      projectList: [],
      tabs: [
        {
          name: "全部交易",
        },
        {
          name: "额外信息",
        },
      ],
      start_time: localStorage.getItem("start_time") || moment().startOf('year').toISOString(), // 从 localStorage 获取日期
      end_time: localStorage.getItem("end_time") || moment().endOf('year').toISOString(), // 从 localStorage 获取日期
      totalAmount: 0, // 总金额
    };
  },
  computed: {
    // 格式化日期显示
    start_time_format() {
      return moment(this.start_time).format("YYYY年MM月DD日");
    },
    end_time_format() {
      return moment(this.end_time).format("YYYY年MM月DD日");
    },
  },
  mounted() {
    this.filterLogList(); // 初始化时过滤数据
  },
  methods: {
    ...mapActions({
      contactGetDetailAction: "contactGetDetail",
      contactGetPayLogAction: "contactGetPayLog",
      contactGetProjectListAction: "contactGetProjectList",
      contactGetServiceAction: "contactGetService",
      contactGetExtInfoAction: "contactGetExtInfo",
    }),
    viewService() {
      this.contactGetServiceAction({
        client_user_id: this.client_user_id,
      })
        .then((res) => {
          window.open(res);
        })
        .catch((error) => {
          this.$Message.error(error);
        });
    },
    open(id) {
      this.client_user_id = id;

      Promise.all([
        this.contactGetDetailAction({
          client_user_id: this.client_user_id,
        }),
        this.contactGetPayLogAction({
          client_user_id: this.client_user_id,
        }),
        this.contactGetProjectListAction({
          client_user_id: this.client_user_id,
        }),
        this.contactGetExtInfoAction({
          client_user_id: this.client_user_id,
        }),
      ])
        .then((values) => {
          this.userInfo = values[0];
          for (let item of values[1]) {
            item.type = 2;
            item.create_time = moment(item.create_time).format(
              "YYYY/MM/DD HH:ss"
            );
          }
          this.logList = values[1];
          this.filterLogList(); // 初始化过滤
          this.projectList = values[2];
          this.extInfo = values[3];
          this.isShowModal = true;
        })
        .catch((error) => {
          this.$Message.error(error);
        });
    },
    close() {
      this.isShowModal = false;
    },
    onBarChange(index) {
      this.currentIndex = index;
    },
    gotoProject(item) {
      this.$router.push({
        name: "project-base",
        params: {
          id: item.project_id,
        },
      });
    },
    // 显示日期选择抽屉
    showTimeDrawer() {
      this.$refs.timeDrawer.open(this.start_time, this.end_time);
    },
    // 设置日期范围
    setTime(obj) {
      this.start_time = obj.start_time;
      this.end_time = obj.end_time;
      localStorage.setItem("start_time", this.start_time); // 存储到 localStorage
      localStorage.setItem("end_time", this.end_time); // 存储到 localStorage
      this.filterLogList(); // 重新过滤数据
    },
    // 过滤交易列表并计算总金额
    filterLogList() {
      const startDate = moment(this.start_time);
      const endDate = moment(this.end_time);

      this.filteredLogList = this.logList.filter((item) => {
        const createTime = moment(item.create_time);
        return createTime.isBetween(startDate, endDate, null, "[]");
      });

      // 计算总金额，确保字段为有效数字
      this.totalAmount = this.filteredLogList.reduce((sum, item) => {
        const salaryAmount = parseFloat(item.salary_amount) || 0;
        const serviceAmount = parseFloat(item.service_amount) || 0;
        return sum + salaryAmount + serviceAmount;
      }, 0);
    },
  },
};
</script>

<style scoped>
.contact-detail-modal-root-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-top: 50px;
  padding-left: 285px;
  background-color: #fafafa;
}
.contact-detail-top-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.contact-detail-info-container {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
  margin-right: 140px;
  width: 350px;
  background-color: #fff;
  border-radius: 8px;
  padding-bottom: 20px;
}
.contact-detail-info-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  min-width: 80%;
}
.contact-detail-bottom-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-right: 140px;
}
.contact-detail-trade-list-container {
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}
.contact-detail-project-list-container {
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: scroll;
}
.ext-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 20px;
}
.tab-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  white-space: nowrap; /* 防止折行 */
}
.tab-list-container {
  flex: 1; /* 标签切换占满剩余空间 */
  max-width: 40%; /* 限制标签切换行的宽度 */
  margin-right: 5px; /* 与日历选择器之间的间距 */
  overflow: hidden; /* 防止内容溢出 */
}
.date-picker-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap; /* 防止折行 */
  min-width: 300px; /* 确保父容器宽度足够 */
}
.date-picker-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 5px; /* 与总金额之间的间距 */
}
.total-amount {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  white-space: nowrap; /* 防止折行 */
  display: inline-flex; /* 确保内容在同一行 */
  align-items: center; /* 垂直居中对齐 */
  gap: 4px; /* 总金额和 fee 组件之间的间距 */
}
.fee-component {
  display: inline-block; /* 确保 fee 组件不折行 */
}
</style>